import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../utils/api';
import { useAuth } from '../contexts/AuthContext';
import { UserIcon, AdminIcon } from '../components/Icons';

const LoginPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState('code');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      let data;
      if (tab === 'login') {
        data = await apiFetch('/login', { method: 'POST', body: JSON.stringify({ username, password }) });
      } else {
        data = await apiFetch('/access-code', { method: 'POST', body: JSON.stringify({ code }) });
      }
      login(data);
      navigate('/', { replace: true });
    } catch (err) {
      setError(err?.detail || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-background">
        <div className="login-container">
          <div className="login-header">
            <div className="company-logo">
              <h1>Freedom Finance</h1>
              <h2>Technologies</h2>
            </div>
            <p className="login-subtitle">AI Response Testing Platform</p>
          </div>

          <div className="login-card">
            <div className="login-tabs">
              <button 
                className={`tab-button ${tab === 'login' ? 'active' : ''}`} 
                onClick={() => setTab('login')}
              >
                <UserIcon size={18} />
                User Login
              </button>
              <button 
                className={`tab-button ${tab === 'code' ? 'active' : ''}`} 
                onClick={() => setTab('code')}
              >
                <AdminIcon size={18} />
                Access Code
              </button>
            </div>

            <form onSubmit={handleSubmit} className="login-form">
              {tab === 'login' ? (
                <>
                  <div className="form-group">
                    <label htmlFor="username">Username</label>
                    <input 
                      id="username"
                      type="text" 
                      placeholder="Enter your username" 
                      value={username} 
                      onChange={e => setUsername(e.target.value)} 
                      autoFocus 
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="password">Password</label>
                    <input 
                      id="password"
                      type="password" 
                      placeholder="Enter your password" 
                      value={password} 
                      onChange={e => setPassword(e.target.value)} 
                      required
                    />
                  </div>
                </>
              ) : (
                <div className="form-group">
                  <label htmlFor="code">Access Code</label>
                  <input 
                    id="code"
                    type="text" 
                    placeholder="Enter your access code" 
                    value={code} 
                    onChange={e => setCode(e.target.value)} 
                    autoFocus 
                    required
                  />
                </div>
              )}
              
              <button type="submit" disabled={loading} className="login-button">
                {loading ? (
                  <div className="button-loading">
                    <div className="spinner-small"></div>
                    <span>Please wait...</span>
                  </div>
                ) : (
                  tab === 'login' ? 'Sign In' : 'Enter'
                )}
              </button>
            </form>

            {error && (
              <div className="login-error">
                <span>⚠️</span>
                {error}
              </div>
            )}
          </div>

          <div className="login-footer">
            <p>© 2025 Freedom Finance Technologies Ltd.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage; 